module.exports = __webpack_public_path__ + "static/scale-model-of-davenport-iowa-0d35f8616929bec3b4662cafeb5a907b.png";